<app-pos-profile-form-wrapper
  data-testid="pos-profile-add-form-wrapper"
  [config]="config"
  [editMode]="false"
  [viewMode]="false"
></app-pos-profile-form-wrapper>
